import {DateTime, Settings} from "luxon";
import {timeZoneHelper} from './time-zone-helper'
import parseDate from "./parse-date";


export const DEFAULT_LANGUAGE = 'en-US';
export const DATE_FORMATS = {
    'ko-KR': {
        DATE: 'yyyy-MM-dd',
        TIME: 'HH:mm:ss',
        DATETIME: 'yyyy-MM-dd HH:mm',
        MONTH: 'yyyy-MM',
    },
    'en-US': {
        DATE: 'dd-LLL-yyyy',
        TIME: 'HH:mm:ss',
        DATETIME: 'dd-LLL-yyyy HH:mm',
        MONTH: 'LLL-yyyy',
    },
    'default': {
        DATE: 'dd-LLL-yyyy',
        TIME: 'HH:mm:ss',
        DATETIME: 'dd-LLL-yyyy HH:mm',
        MONTH: 'LLL-yyyy',
    },
};


/**
 * 시간 관련 포맷 변환을 지원합니다.
 */
class DateFormatHelper {

    _format = DATE_FORMATS.default;

    constructor() {
        Settings.defaultZoneName = timeZoneHelper.getTimeZone();
        this.setLanguage(timeZoneHelper.getBrowserLanguage());
    }

    /**
     * MPS 로그인 된 유저 정보를 설정합니다.
     * @param user
     */
    setUser(user = null) {
        let language;
        if (user) {
            language = user.languageCode || null;
            if (user.countryCode) language += '-' + user.countryCode;
        }
        this.setLanguage(language);
    }

    setLanguage(language = null) {
        this.language = language ? language : DEFAULT_LANGUAGE;
        console.log(this.language);
        this._formats = DATE_FORMATS[this.language] || DATE_FORMATS.default;
        console.log(this._formats);
    }

    format(v, format) {
        if (!v || v.length === 0) return '';
        return DateTime.fromISO(v).toFormat(format);
    }

    adminFormat(v) {
        if (!v || v.length === 0) return '';
        return DateTime.fromSQL(v).plus({ hours: 9}).toFormat('yyyy-MM-dd HH:mm:ss');
    }

    formatDate = (v) => this.format(v, this._formats.DATE);
    formatTime = (v) => this.format(v, this._formats.TIME);
    formatDateTime = (v) => this.format(v, this._formats.DATETIME);
    formatMonth = (v) => this.format(v, this._formats.MONTH);
    formatAdminDate = (v) => this.adminFormat(v);
    parse = (v) => parseDate(v);
}

const dateHelper = new DateFormatHelper(); // 싱글턴

export {dateHelper}
